export default "__VITE_ASSET__CxWXITuB__"